// Funções puras de apoio ao chat (formatação e identidade visual).

const AVATAR_COLORS = ['#7367f0', '#00a3a3', '#e8590c', '#2f9e44', '#c2255c', '#1971c2', '#9c36b5', '#d9480f']

export function uuid() {
  if (window.crypto && window.crypto.randomUUID) return window.crypto.randomUUID()

  // Contexto sem HTTPS não tem randomUUID; getRandomValues continua disponível.
  const b = window.crypto.getRandomValues(new Uint8Array(16))
  b[6] = (b[6] % 16) + 64
  b[8] = (b[8] % 64) + 128
  const h = Array.from(b, x => x.toString(16).padStart(2, '0'))

  return `${h.slice(0, 4).join('')}-${h.slice(4, 6).join('')}-${h.slice(6, 8).join('')}-${h.slice(8, 10).join('')}-${h.slice(10).join('')}`
}

export function initials(name) {
  const parts = String(name || '?').trim().split(/\s+/)
  const first = parts[0] ? parts[0][0] : '?'
  const last = parts.length > 1 ? parts[parts.length - 1][0] : ''

  return (first + last).toUpperCase()
}

/** Cor estável por usuário: o mesmo nome tem sempre a mesma cor. */
export function avatarColor(seed) {
  const s = String(seed || '')
  let hash = 0
  for (let i = 0; i < s.length; i += 1) hash = (hash * 31 + s.charCodeAt(i)) % 2147483647

  return AVATAR_COLORS[hash % AVATAR_COLORS.length]
}

export function formatBytes(bytes) {
  if (bytes < 1024) return `${bytes} B`
  if (bytes < 1024 * 1024) return `${(bytes / 1024).toFixed(0)} KB`

  return `${(bytes / 1024 / 1024).toFixed(1)} MB`
}

export function formatDuration(seconds) {
  const s = Math.max(0, Math.round(seconds || 0))

  return `${Math.floor(s / 60)}:${String(s % 60).padStart(2, '0')}`
}

const startOfDay = d => new Date(d.getFullYear(), d.getMonth(), d.getDate()).getTime()

/** 0 = hoje, 1 = ontem, n = n dias atrás (pelo calendário, não por 24 h). */
export function daysAgo(iso, now = new Date()) {
  return Math.round((startOfDay(now) - startOfDay(new Date(iso))) / 86400000)
}

export function timeLabel(iso, locale) {
  return new Date(iso).toLocaleTimeString(locale, { hour: '2-digit', minute: '2-digit' })
}

/** Dia por extenso para os separadores da conversa ("Hoje" e "Ontem" vêm traduzidos de fora). */
export function dayLabel(iso, locale, { today, yesterday }) {
  const diff = daysAgo(iso)
  if (diff === 0) return today
  if (diff === 1) return yesterday
  if (diff < 7) return new Date(iso).toLocaleDateString(locale, { weekday: 'long' })

  return new Date(iso).toLocaleDateString(locale, { day: '2-digit', month: 'long', year: 'numeric' })
}

/** Rótulo curto da lista de conversas: hora de hoje, "Ontem" ou a data. */
export function listTimeLabel(iso, locale, yesterday) {
  if (!iso) return ''
  const diff = daysAgo(iso)
  if (diff === 0) return timeLabel(iso, locale)
  if (diff === 1) return yesterday

  return new Date(iso).toLocaleDateString(locale, { day: '2-digit', month: '2-digit', year: '2-digit' })
}

/** Prazo para editar a própria mensagem (o servidor também confere: ChatService::EDIT_WINDOW_MINUTES). */
export const EDIT_WINDOW_MS = 15 * 60 * 1000

export function messagePreviewKey(message) {
  return { image: 'chat.preview.image', audio: 'chat.preview.audio', file: 'chat.preview.file' }[message.kind] || null
}

/** O back manda a foto como caminho relativo à API; o navegador precisa da URL completa (a mesma base do avatar da navbar). */
export function resolvePhoto(apiUrl, path) {
  if (!path) return null

  return /^(https?:|data:|blob:)/.test(path) ? path : `${apiUrl}${path}`
}
